import styled from 'styled-components'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  justify-content: center;
  align-items: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
`

export const ProfessionalPicture = styled.img`
  width: 80px;
  height: 80px;
  box-shadow: 0px 2px 10px -6px #252525;
  border: ${({ selected }) => selected ? '2px solid #FFC100' : 'none'};
  border-radius: 15px;
`

export const ProfessionalsGrid = styled.div`
  width: 100%;
  display: grid;
  justify-items: stretch;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 15px;
`

export const ProfessionalBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  margin-bottom: 10px;
  border: 0px;
  gap: 8px;
  cursor: pointer;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin: 0px;

  &:hover {
    cursor: pointer;
  }
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

// O texto acompanha a cor e o peso do botão da lib
export const ButtonText = styled(SubTitle)`
  color: inherit;
  margin: 0px;
  font-weight: inherit;
`

export const Button = styled(LookButton).attrs(buttonLook({ variant: 'secondary' }))`
  width: 160px;
  align-self: center;
  margin: 10px 5px 0px;
`
